export const px2rem = (pxValue?: number, defaultValue: string = "initial") => {
	if (typeof pxValue !== "undefined") {
		return `${Number((pxValue / 16).toFixed(4))}rem`;
	}
	return defaultValue;
};

export const px2vw = (pxValue: number) => {
	return `${Number(((pxValue * 100) / 375).toFixed(4))}vw`;
};

export const MWEB_MINWIDTH = 750;
